export const ADD_KITCHEN_DISPLAY = "ADD_KITCHEN_DISPLAY"
export const EDIT_KITCHEN_DISPLAY = "EDIT_KITCHEN_DISPLAY"
export const DELETE_KITCHEN_DISPLAY = "DELETE_KITCHEN_DISPLAY"